<template>
  <div class="request-approval-container">
    <Email v-show="$store.state.modalStore.showNewVendorEmail" />
    <!-- <Loading v-if="$store.state.globalLoading" /> -->
    <div class="request-approval-dialog">
      <div class="request-approval-content">
        <div class="request-approval-body">
          <div class="req-app-full-container">
            <div class="req-app-full-tittle">TIKET VENDOR BARU</div>
            <div class="req-app-full-wrapper" v-if="dataUpdate">
              <div class="req-app-half-container">
                <div class="half-input-wrapper">
                  <div class="hiw-label">Request ID</div>
                  <input type="text" class="hiw-text" placeholder="Otomatis dari Sistem" :value="code" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Deskripsi <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="desc" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Nama Pengadaan <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="nama_pengadaan" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Kategori</div>
                  <select v-model="kategori_id" class="hiw-text" disabled>
                    <option v-for="(option, index) in kategoryList" :key="index" :value="option.id">
                      {{ option.name }}
                    </option>
                  </select>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Nama Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="nama_vendor" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    PIC Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="pic_vendor" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    No. Telepon PIC <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="no_telepon" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Email Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="email" class="hiw-text" v-model="email_vendor" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Priority</div>
                  <select v-model="priority" class="hiw-text" disabled>
                    <option v-for="(option, index) in priorityList" :key="index" :value="option.id">
                      {{ option.desc }}
                    </option>
                  </select>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label" style="cursor: pointer">
                    Dokumen Petunjuk
                  </div>
                  <label class="btn btn-default btn-file" style="width:100%; text-align:left">
                    <i class="fas fa-download" @click="downloadDoc()"></i>
                  </label>
                </div>
              </div>
              <div class="req-app-half-container">
                <!-- <div class="half-input-wrapper">
                    <div class="hiw-label">Due By</div>
                    <div class="hiw-multiple">
                      <input class="hiw-2-row" type="date">
                      <input class="hiw-2-row" type="date">
                    </div>
                  </div> -->
                <div class="half-input-wrapper">
                  <div class="hiw-label">Tujuan Pendaftaran</div>
                  <select v-model="tujuan_pendaftaran" class="hiw-multiple" disabled>
                    <option v-for="(option, index) in tujuan_list" :key="index" :value="option.id">
                      {{ option.name }}
                    </option>
                  </select>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Bidang Usaha</div>
                  <div class="hiw-multiple">
                    <label class="hiw-2-row"><input type="radio" value="1" v-model="bidang_usaha_id" disabled
                        style="margin-right: 10px" />Badan Usaha</label>
                    <label class="hiw-2-row"><input type="radio" value="2" v-model="bidang_usaha_id" disabled
                        style="margin-right: 10px" />Perorangan</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Registrasi ke Sistem <span class="text-ast">*</span>
                  </div>
                  <div class="hiw-multiple">
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_ariba" value="1"
                        style="margin-right: 10px" disabled />ARIBA</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_gems" value="1" disabled
                        style="margin-right: 10px" />SAP GEMS</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_bce" value="1" disabled
                        style="margin-right: 10px" />SAP BCE</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_bkes" value="1" disabled
                        style="margin-right: 10px" />SAP BKES</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Tipe Pendaftaran Vendor</div>
                  <div class="hiw-multiple">
                    <label class="hiw-4-row popup"><input type="radio" value="1" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" disabled />Nasional
                      <span class="popuptext">PT, PT TBK, YAYASAN, CV, BUMDES, KOPERASI,
                        PERKUMPULAN</span></label>
                    <label class="hiw-4-row popup"><input type="radio" value="2" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" disabled />Internasional
                      <span class="popuptext">
                        PTE LTD, LTD, PTE, CORP, INC</span></label>
                    <label class="hiw-4-row popup"><input type="radio" value="3" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" disabled />Khusus
                      <span class="popuptext">Instansi Pemerintah, Bank, Rumah Sakit, Hotel, Sekolah,
                        Demurage, E-commerce</span></label>
                    <label class="hiw-4-row popup"><input type="radio" value="4" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" disabled />Internal Memo
                      <span class="popuptext">
                        Dokumen tdk ada/lengkap, Produsen, Pabrikan, HAKI,
                        Emergency, Direksi appointment</span>
                    </label>
                    <label class="btn btn-default btn-file" style="width:100%; text-align:left"
                      v-if="type_pendaftaran_id == 4" @click="downloadDocMemo()">
                      <i class="fas fa-download"></i>
                      {{ memoFiles }}
                    </label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Penilaian</div>
                  <div class="hiw-multiple">
                    <label class="hiw-2-row"><input type="checkbox" v-model="assesment_k3l" value="k3l"
                        style="margin-right: 10px" disabled />K3L</label>
                    <label class="hiw-2-row"><input type="checkbox" v-model="assesment_kplh" value="kplh"
                        style="margin-right: 10px" disabled />KPLH</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Dokumen Legalitas</div>
                  <!-- <input type="file" class="hiw-text"> -->
                  <div class="hiw-multiple">
                    <label class="btn btn-default btn-file" style="width:100%; text-align:left"
                      @click="downloadLegalitas()">
                      <i class="fas fa-download"></i>
                      {{ files }}
                    </label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Note</div>
                  <textarea class="hiw-area" v-model="note" disabled />
                </div>
              </div>
            </div>
            <div class="req-app-full-btn-wrapper" v-if="$route.params.status != 3 && $route.params.status != 4">
              <div class="req-app-btn-submit mr10" @click="sendEmail()" v-if="$route.params.status == 6 &&
                $get($store, 'state.role_id') == 1 &&
                !$get($route, 'query.status')
              ">
                Resend Email
              </div>
              <div class="req-app-btn-submit mr10" @click="approve()" v-if="$route.params.status != 9 &&
                $route.params.status != 6 &&
                $get($store, 'state.role_id') == 1
              ">
                Approve
              </div>
              <div class="req-app-btn-submit mr10" @click="approveHead()" v-if="($route.params.status == 9 &&
                $get($store, 'state.role_id') == 2) ||
                ($route.params.status != 10 &&
                  $get($store, 'state.role_id') == 2)
              ">
                Approve Head
              </div>
              <div class="req-app-btn-submit mr10" @click="reject()" v-if="($route.params.status != 9 &&
                $route.params.status != 6 &&
                $get($store, 'state.role_id') == 1) ||
                ($route.params.status == 2 &&
                  $get($store, 'state.role_id') == 1)
              ">
                Reject
              </div>
              <div class="req-app-btn-submit mr10" @click="reviseNow()" v-if="($route.params.status != 6 &&
                $route.params.status != 9 &&
                $route.params.status != 10 &&
                $get($store, 'state.role_id') == 1) ||
                ($route.params.status == 2 &&
                  $get($store, 'state.role_id') == 1)
              ">
                {{
                  editingStatus == 1 || editingStatus == true
                    ? `Close ( ${editingUser} )`
                    : `Revise Now`
                }}
              </div>
              <div class="req-app-btn-submit mr10" @click="needReview()" v-if="(($route.params.status != 9 &&
                $route.params.status != 10 &&
                $route.params.status != 6 &&
                $get($store, 'state.role_id') == 1) ||
                ($route.params.status == 2 &&
                  $get($store, 'state.role_id') == 1)) &&
                $route.params.type != 9 &&
                $route.params.status == 2
              ">
                Need Review
              </div>
              <div class="req-app-btn-submit mr10" @click="reviewHead()" v-if="($route.params.status == 9 &&
                $get($store, 'state.role_id') == 2) ||
                ($route.params.status != 10 &&
                  $get($store, 'state.role_id') == 2)
              ">
                Review Head
              </div>
              <!-- <div
                class="req-app-btn-submit mr10"
                @click="postpone()"
                v-if="
                  $route.params.status == 6 &&
                    $get($store, 'state.role_id') == 1
                "
              >
                Postpone
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '../../services/config'
export default {
  components: {
    Email: () => import('@/components/modal/newVendorEmail.vue'),
  },
  data() {
    return {
      isHead: false,
      chooseBu: '',
      chooseTypeRegister: '',
      chooseAssesment: [],
      chooseServer: [],
      files: [],
      memoFiles: [],

      priorityList: [
        {
          id: 1,
          desc: 'Very High',
        },
        {
          id: 2,
          desc: 'High',
        },
        {
          id: 3,
          desc: 'Medium',
        },
        {
          id: 4,
          desc: 'Low',
        },
        {
          id: 5,
          desc: 'Very Low',
        },
      ],
      kategoryList: [
        {
          id: 1,
          desc: 'CAT - CATEGORY 1',
        },
        {
          id: 2,
          desc: 'GIL - GA,IT & LONG TAILS',
        },
        {
          id: 3,
          desc: 'FEL - FUEL, LUBRICANT & ENERGY',
        },
        {
          id: 4,
          desc: 'MRR - MAINTENANCE & REPAIR, RENTAL',
        },
        {
          id: 5,
          desc: 'CPI - COAL PROCESSING & INFRASTRUCTURE PROJECT',
        },
      ],
      tujuan_list: [],

      code: '',
      desc: '',
      nama_pengadaan: '',
      tujuan_pendaftaran: 1,
      kategori_id: 1,
      nama_vendor: '',
      pic_vendor: '',
      no_telepon: '',
      email_vendor: '',
      priority: 5,

      //due_date:,
      bidang_usaha_id: 1,
      type_pendaftaran_id: 1,
      register_ariba: true,
      register_gems: false,
      register_bce: false,
      register_bkes: false,
      freeze_ariba: true,
      freeze_gems: true,
      freeze_bkes: true,
      freeze_bce: true,
      assesment_k3l: false,
      assesment_kplh: false,
      freeze_k3l: false,
      freeze_kplh: false,
      note: '',

      vendors: [],
      isOpen: false,
    }
  },
  async created() {
    await this.getVendorCategory()
    await this.getPurposeTicket()
    await this.$store.dispatch('myRequest/requestDetail', this.$route.params.id)
    if (this.$get(this.$route, 'query.status')) {
      this.$store.commit(
        'SET_NOTIF',
        'Telah melalui tahap Validasi, Email tidak dapat di rubah.'
      )
    } else if (this.$get(this.$route, 'query.id')) {
      if (this.$get(this.$route, 'query.id') == '625d1d1efb9f82520177cf84') {
        this.isHead = true
      }
    }
    await this.$store.dispatch('editingStore/getRequestStatus', {
      id: this.$route.params.id,
      name: 'revise_sipm_approve',
    })
  },
  computed: {
    editingStatus() {
      return this.$get(
        this.$store,
        'state.editingStore.revise_sipm_approve.is_open',
        0
      )
    },
    editingUser() {
      return this.$get(
        this.$store,
        'state.editingStore.revise_sipm_approve.open_by',
        ''
      )
    },
    editingId() {
      return this.$get(
        this.$store,
        'state.editingStore.revise_sipm_approve.id',
        ''
      )
    },
    theFileName() {
      if (this.files.length > 0 && 'name' in this.files[0]) {
        return this.files[0].name
      }
      return this.labelPlaceholder
    },
    theFileName() {
      if (this.files.length > 0 && 'name' in this.files[0]) {
        return this.files[0].name
      }
      return this.labelPlaceholder
    },
    dataUpdate() {
      this.user_id = this.$get(this.$store, 'state.myRequest.detail.user_id')
      this.code = this.$get(this.$store, 'state.myRequest.detail.code', '')
      this.desc = this.$get(this.$store, 'state.myRequest.detail.desc', '')
      this.files = this.$get(
        this.$store,
        'state.myRequest.detail.dokumen_legalitas_originalname',
        ''
      )
      this.tujuan_pendaftaran = this.$get(
        this.$store,
        'state.myRequest.detail.tujuan_pendaftaran',
        null
      )

      this.memoFiles = this.$get(
        this.$store,
        'state.myRequest.detail.internal_memo_originalname',
        'Upload Internal Memo'
      )
      this.nama_pengadaan = this.$get(
        this.$store,
        'state.myRequest.detail.nama_pengadaan',
        ''
      )
      this.kategori_id = this.$get(
        this.$store,
        'state.myRequest.detail.kategori_id',
        1
      )

      this.nama_vendor = this.$get(
        this.$store,
        'state.myRequest.detail.nama_vendor'
      )
      this.pic_vendor = this.$get(
        this.$store,
        'state.myRequest.detail.pic_vendor'
      )
      this.no_telepon = this.$get(
        this.$store,
        'state.myRequest.detail.no_telepon'
      )
        ? this.$get(this.$store, 'state.myRequest.detail.no_telepon')
        : this.$get(this.$store, 'state.myRequest.detail.pic_no_telepon')
      this.email_vendor = this.$get(
        this.$store,
        'state.myRequest.detail.email_vendor'
      )
        ? this.$get(this.$store, 'state.myRequest.detail.email_vendor')
        : this.$get(this.$store, 'state.myRequest.detail.pic_email')
      this.priority = this.$get(
        this.$store,
        'state.myRequest.detail.priority',
        5
      )
      this.bidang_usaha_id = this.$get(
        this.$store,
        'state.myRequest.detail.bidang_usaha_id',
        1
      )
      this.type_pendaftaran_id = this.$get(
        this.$store,
        'state.myRequest.detail.type_pendaftaran_id',
        1
      )
      this.register_gems = this.$get(
        this.$store,
        'state.myRequest.detail.register_gems'
      )
      this.register_bce = this.$get(
        this.$store,
        'state.myRequest.detail.register_bce',
        false
      )
      this.register_bkes = this.$get(
        this.$store,
        'state.myRequest.detail.register_bkes',
        false
      )
      this.assesment_k3l = this.$get(
        this.$store,
        'state.myRequest.detail.assesment_k3l',
        false
      )
      this.assesment_kplh = this.$get(
        this.$store,
        'state.myRequest.detail.assesment_kplh',
        false
      )
      this.note = this.$get(this.$store, 'state.myRequest.detail.note', '')

      return true
    },
  },
  watch: {
    tujuan_pendaftaran(newValue) {
      if (this.tujuan_list.length > 0) {
        const { ariba_registration, gems_registration, bce_registration, bkes_registration } = this.tujuan_list.filter(
          i => i.id == newValue
        )[0]

        if (newValue == 1 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = false
          this.freeze_kplh = false
        } else if (newValue == 1 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 2 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = false
          this.freeze_kplh = false
        } else if (newValue == 2 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 3 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = false
          this.freeze_kplh = false
        } else if (newValue == 3 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 4 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 4 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 5 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 5 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        }
      }
    },
  },
  methods: {
    async getPurposeTicket() {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${api}/api/v1/m-purpose-ticket`,
        })

        this.tujuan_list = data.data
      } catch (error) {
        // do nothing
      }
    },
    async getVendorCategory() {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${api}/api/v1/m-ticket-category`,
        })

        this.kategoryList = data.data
      } catch (error) {
        // do nothing
      }
    },
    resetForm() {
      this.desc = ''
      this.nama_pengadaan = ''
      this.kategori_id = 1
      this.nama_vendor = ''
      this.pic_vendor = ''
      this.no_telepon = ''
      this.priority = 5
      this.bidang_usaha_id = 1
      this.type_pendaftaran_id = 1
      this.register_gems = false
      this.register_bce = false
      this.register_bkes = false
      this.assesment_k3l = false
      this.assesment_kplh = false
      this.note = null
      this.files = []
      this.email_vendor = ''
    },
    sendEmail() {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalReview',
        value: true,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'request_id',
        value: this.$route.params.id,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'reviewState',
        value: 4,
      })
    },
    fileChangeHandler(e) {
      this.files = Array.from(e.target.files)
    },
    downloadDoc() {
      const fileName = `JKT - ISUPPLIER\ISUPPLIER\Dokumen Isupplier\Dokumen Petunjuk.pdf`
      const fileLocation = `JKT%20-%20ISUPPLIER/ISUPPLIER/Dokumen%20Isupplier/Dokumen%20Petunjuk.pdf`
      if (fileLocation) {
        let linkUrl = `${api}/file/${fileLocation}`
        this.$store.commit('level1/SET_LOADING', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(fileName))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('level1/SET_LOADING', false)
          })
          .catch(error => {
            this.$store.commit('level1/SET_LOADING', false)
          })
      }
    },
    downloadLegalitas() {
      let link = this.$get(
        this.$store,
        'state.myRequest.detail.dokumen_legalitas'
      )
      if (link) {
        let linkUrl = `${api}/uploads/${link}`
        this.$store.commit('level1/SET_LOADING', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('level1/SET_LOADING', false)
          })
          .catch(error => {
            this.$store.commit('level1/SET_LOADING', false)
          })
      }
    },
    downloadDocMemo() {
      let link = this.$get(this.$store, 'state.myRequest.detail.internal_memo')
      if (link) {
        let linkUrl = `${api}/uploads/${link}`
        this.$store.commit('level1/SET_LOADING', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('level1/SET_LOADING', false)
          })
          .catch(error => {
            this.$store.commit('level1/SET_LOADING', false)
          })
      }
    },
    approve() {
      this.$store.commit('SET_GLOBAL_LOADING', true)
      const url = `${api}/api/v1/vendor-level-1?page=1&limit=10&search=${this.nama_vendor}`
      axios({
        method: 'get',
        url,
      })
        .then(async ({ data }) => {
          await this.$store.commit('SET_GLOBAL_LOADING', false)

          let searchName = data.data.filter(
            i => i.nama_vendor == this.nama_vendor
          )

          if (searchName.length == 1) {
            if (
              confirm(
                'Nama Vendor terdeteksi duplikat, apakah Anda yakin untuk melanjutkan pendaftaran Vendor?'
              )
            ) {
              // Save it!
              await this.$store.dispatch('approvalSheet/approveVendor', {
                id: this.$route.params.id,
              })
            } else {
              // Do nothing!
            }
          }
        })
        .catch(async error => {
          await this.$store.commit('SET_GLOBAL_LOADING', false)
          await this.$store.dispatch('approvalSheet/approveVendor', {
            id: this.$route.params.id,
          })
        })
    },
    approveHead() {
      this.$store.dispatch('approvalSheet/approveHead', {
        id: this.$route.params.id,
      })
    },
    reviewHead() {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalReview',
        value: true,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'request_id',
        value: this.$route.params.id,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'reviewState',
        value: 1,
      })
    },
    reject() {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalReview',
        value: true,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'request_id',
        value: this.$route.params.id,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'reviewState',
        value: 2,
      })
    },
    async reviseNow() {
      if (this.editingStatus == 1 || this.editingStatus == true) {
        await this.$store.dispatch('editingStore/deleteEditingStatus', {
          id: this.editingId,
          is_open: 0,
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          request_id: this.$route.params.id,
          name: 'revise_sipm_approve',
        })
      } else {
        await this.$store.dispatch('editingStore/addEditingStatus', {
          is_open: 1,
          desc: 'revise_sipm_approve',
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          request_id: this.$route.params.id,
          name: 'revise_sipm_approve',
          onSuccess: () => {
            this.$router.push({
              path: `/approval/update-vendor/${this.$route.params.id}/${this.$route.params.status}`,
            })
          },
        })
      }
    },
    needReview() {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalReview',
        value: true,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'request_id',
        value: this.$route.params.id,
      })
      this.$store.commit('approvalSheet/SET_DATA', {
        name: 'reviewState',
        value: 3,
      })
    },
    postpone() {
      this.$store.dispatch('approvalSheet/postpone', {
        id: this.$route.params.id,
      })
    },
  },
}
</script>
